import { PRODUCT_ROUTE_NAME } from '@/libs/route-name';
import type { RouteRecordRaw } from 'vue-router';

export const CategoryRoute = (): RouteRecordRaw => ({
  path: '/category',
  name: PRODUCT_ROUTE_NAME.CATEGORY,
  component: () => import('@/pages/product/category.vue'),
});

export const ProductCategoryRoute = (): RouteRecordRaw => ({
  path: '/product-category/:category',
  name: PRODUCT_ROUTE_NAME.PRODUCT_CATEGORY,
  component: () => import('@/pages/product/product-category.vue'),
});

export const AddCategoryRoute = (): RouteRecordRaw => ({
  path: '/add-category',
  name: PRODUCT_ROUTE_NAME.ADD_CATEGORY,
  component: () => import('@/pages/product/add-category.vue'),
});

export const EditCategoryRoute = (): RouteRecordRaw => ({
  path: '/edit-category/:slug',
  name: PRODUCT_ROUTE_NAME.EDIT_CATEGORY,
  component: () => import('@/pages/product/edit-category.vue'),
});
